export default __webpack_public_path__ + "static/map-f7ff28998c9d55ecf3107417a3c65889.pdf";